import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { canEditLinkedAccountOwnerAndSyncSelector } from '../../../../../../../CommonSelectors/CommonAreaSelector';
import { useAccountFormContext } from '../context/useAccountFormContext';

export const useCanEditLinkedAccountOwnerAndSync = () => {
  const { accounts, localSaveOptions, accountId } = useAccountFormContext();
  const canEditLinkedAccountOwnerAndSync = useSelector(canEditLinkedAccountOwnerAndSyncSelector);

  const selectedAccount = localSaveOptions
    ? localSaveOptions.data?.bankAccount
    : accounts.find(({ AccountId }) => AccountId === accountId);

  const isLinkedAccount = !!selectedAccount?.IsLinked;

  return {
    canEditOwnerAndSyncOnly:
      !localSaveOptions && isLinkedAccount && canEditLinkedAccountOwnerAndSync,
  };
};

/** When the form is globally disabled, owner and sync fields remain editable in limited linked-account mode. */
export const useAccountFormFieldDisabled = (ownerAndSyncField = false) => {
  const {
    formState: { disabled },
  } = useFormContext();
  const { canEditOwnerAndSyncOnly } = useCanEditLinkedAccountOwnerAndSync();

  if (ownerAndSyncField && canEditOwnerAndSyncOnly) {
    return false;
  }

  return disabled;
};
